const style = {
  manageFieldsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'spaced-between',
    alignItems: 'center',
    borderBottom: '1px solid #b6b6b8',
    paddingBottom: 5,
    paddingTop: 5,
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  },
  manageFieldsLabel: {
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
  },
  manageFieldsName: {
    alignItems: 'center',
    textAlign: 'center',
    width: '80%',
    marginRight: 5,
    marginLeft: 5,
    wordWrap: 'normal',
  },
  manageFieldsSortOrder: {
    alignItems: 'center',
    textAlign: 'center',
    width: '20%',
    marginLeft: 5,
  },
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
};

export default style;
